/* eslint-disable no-constant-condition */
import { useEffect, useState } from "react";
import { Alert, Button, Col, Modal, Row, Space, Table, Tag } from "antd";
import useForm from "../../../hooks/useForm";
import { EditOutlined } from "@ant-design/icons";
import InputForm from "../../utils/InputForm";
import UploatEvidences from "./evidences/uploatEvidences";
import DeclineEvidenceView from "./evidences/DeclineEvidence";
import UsePermissions from "../../../hooks/usePermissions";

export default function EvidenciesView(props) {
  const { faltante, setFaltante, onRefetch } = props;

  const { hasPermission, hasAllPermissionsChild1 } = UsePermissions();

  const [viewEvidences, setViewEvidences] = useState(true);
  const [openUpload, setOpenUpload] = useState(false);
  const [openDecline, setOpenDecline] = useState(false);

  const [alert, setAlert] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [isEdit, setIsEdit] = useState(false);

  const [evidences, setEvidences] = useState([]);

  const [dataToDecline, setDataToDecline] = useState({
    codigoFaltante: "",
    evidenciaId: 0,
  });

  const { values, handleChange, resetForm, setInitialValues } = useForm({
    type: 0,
    description: "",
    evidenciaId: 0,
    estatusId: 0,
    evidenceUrl: "",
  });

  const [fileSelected, setFileSelected] = useState({
    base64Data: null,
    previewUrl: null,
    name: "",
  });

  const hasDeclineEvidencePermission = hasPermission("CHILD1", "evidence.decline");

  const hasEditEvidencePermission = hasPermission("CHILD1", "evidence.edit");

  const hasCreateEvidencePermission = hasPermission("CHILD1", "evidence.create");

  useEffect(() => {
    setEvidences(faltante?.data?.evidencias);

    if (faltante.data?.evidencias.length >= 10) {
      setAlert({
        open: true,
        message: "Máximo 10 evidencias. Edite una existente para aclarar.",
        type: "warning",
      });
    } else if (faltante.data?.FIESTATUSID === 4) {
      setAlert({
        open: true,
        message: "Faltante aclarado.",
        type: "success",
      });
    } else if (faltante.data?.FIESTATUSID === 7) {
      setAlert({
        open: true,
        message: "Faltante cancelado.",
        type: "error",
      });
    } else {
      setAlert({
        open: false,
        message: "",
        type: "",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [faltante.data]);

  const handleEditData = (item) => {
    setInitialValues({
      type: item.tipoEvidencia || 0,
      description: item.descripcion || "",
      evidenciaId: item.evidenciaId || 0,
      estatusId: item.estatusId || 0,
      evidenceUrl: item.urlEvidencia || "",
    });
  };

  const handleDeclineData = (item) => {
    setDataToDecline({
      codigoFaltante: item.codigoFaltante,
      evidenciaId: item.evidenciaId,
    });
  };

  const EvidencesColumns = [
    {
      title: "Fecha",
      dataIndex: "fechaModificacion",
      key: "fechaModificacion",
      sorter: (a, b) => new Date(a.fechaModificacion) - new Date(b.fechaModificacion),
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
      // with: "50%",
    },
    {
      title: "Estatus",
      render: (item) => {
        switch (item.estatusId) {
          case 1:
            return <Tag color="green">Activo</Tag>;
          case 2:
            return <Tag color="red">Rechazado</Tag>;
          case 3:
            return <Tag color="blue">Inactivo</Tag>;
          default:
            return <Tag color="gray">Desconocido</Tag>;
        }
      },
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Rechazado",
          value: 2,
        },
      ],
      onFilter: (value, record) => record.estatusId === Number(value),
    },
    {
      title: "Tipo",
      // with: "10%",
      render: (item) => {
        return item.tipoEvidencia === 1 ? (
          <Tag color="blue">Imagen JPG</Tag>
        ) : (
          <Tag color="orange">PDF</Tag>
        );
      },
      filters: [
        {
          text: "Imagen JPG",
          value: 1,
        },
        {
          text: "PDF",
          value: 2,
        },
      ],
      onFilter: (value, record) => record.tipoEvidencia === Number(value),
    },
    {
      title: "Acciones",
      render: (item) => (
        <>
          <Space size="middle">
            {(hasEditEvidencePermission || hasAllPermissionsChild1) && (
              <Button
                onClick={() => {
                  handleEditData(item);
                  setIsEdit(true);
                  setViewEvidences(false);
                  setOpenUpload(true);
                }}
                className={
                  true
                    ? `button-styles-detalais-catalogo`
                    : `button-styles-detalais-catalogo-disabled`
                }
                disabled={faltante.data?.FIESTATUSID === 4 || faltante.data?.FIESTATUSID === 7}
              >
                <EditOutlined style={{ fontSize: 20 }} />
              </Button>
            )}

            {(hasDeclineEvidencePermission || hasAllPermissionsChild1) && (
              <Button
                onClick={() => {
                  setOpenDecline(true);
                  handleDeclineData(item);
                }}
                // className={
                //   true
                //     ? `button-styles-detalais-catalogo-analist`
                //     : `button-styles-detalais-catalogo-disabled`
                // }
                // disabled={item.evidencias.length > 0 ? false : true}
                type="link"
                disabled={
                  item.estatusId === 2
                    ? true
                    : false || faltante.data?.FIESTATUSID === 4 || faltante.data?.FIESTATUSID === 7
                }
              >
                Rechazar
              </Button>
            )}
          </Space>
        </>
      ),
    },
  ];

  const handleOnCancel = () => {
    setFaltante({
      data: {
        evidencias: [],
        analistComment: "",
        faltanteCode: "",
      },
      open: false,
    });
    setViewEvidences(true);
    setIsEdit(false);
    setOpenUpload(false);
    resetForm();
    setFileSelected({
      base64Data: null,
      previewUrl: null,
      name: "",
    });
  };

  const addEvidenceDisabled =
    faltante.data?.evidencias.length >= 10 ||
    faltante.data?.FIESTATUSID === 4 ||
    faltante.data?.FIESTATUSID === 7
      ? true
      : false;

  return (
    <>
      <Modal open={faltante.open} onCancel={handleOnCancel} width={850} footer={null}>
        {viewEvidences && (
          <>
            <Row justify="center">
              <div className="input-content-titulo">Evidencias</div>
            </Row>
            <Row justify="center" className="pb-1">
              {alert.open ? <Alert message={alert.message} type={alert.type} showIcon /> : null}
            </Row>

            <Row justify="space-between" align="bottom" className="pb-3">
              <Col xs={20} md={9} al>
                <InputForm
                  handleChange={null}
                  value={faltante.data?.faltanteCode}
                  name={"FCCODIGOFALTANTE"}
                  type={"text"}
                  label={"Código faltante"}
                  disabled={true}
                />
              </Col>
              <Col xs={15} md={5} al>
                {(hasCreateEvidencePermission || hasAllPermissionsChild1) && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setViewEvidences(false);
                      setOpenUpload(true);
                    }}
                    className="button-styles-add-element"
                    disabled={addEvidenceDisabled}
                  >
                    Agregar evidencia
                  </Button>
                )}
              </Col>
            </Row>
            <Row justify="space-around">
              <Table
                columns={EvidencesColumns}
                dataSource={evidences}
                pagination={false}
                scroll={{ y: 240 }}
                rowKey={"evidenciaId"}
              />
            </Row>
          </>
        )}
        {openUpload && (
          <>
            <UploatEvidences
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              setViewEvidences={setViewEvidences}
              faltante={faltante.data}
              values={values}
              handleChange={handleChange}
              resetForm={resetForm}
              setFaltante={setFaltante}
              onRefetch={onRefetch}
              fileSelected={fileSelected}
              setFileSelected={setFileSelected}
              setOpenUpload={setOpenUpload}
            />
          </>
        )}
        {openDecline && (
          <>
            <DeclineEvidenceView
              openDecline={openDecline}
              setOpenDecline={setOpenDecline}
              dataToDecline={dataToDecline}
              onRefetch={onRefetch}
              faltante={faltante}
              setFaltante={setFaltante}
            />
          </>
        )}
      </Modal>
    </>
  );
}
